export default {
  methods: {
    isSameDay(dateToCheck, originalDate)
    {
      return (dateToCheck.getDate() === originalDate.getDate()
        && dateToCheck.getMonth() === originalDate.getMonth()
        && dateToCheck.getFullYear() === originalDate.getFullYear())
    }
  }
}